import { Component, OnInit, ViewEncapsulation, HostListener, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonService } from '../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { AsideComponent } from '../aside/aside.component';
import { NgClass, NgStyle } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { TitleComponent } from '../shared/title/title.component';
import { SpinnerComponent } from '../shared/spinner/spinner.component';
import { TranslateModule } from '@ngx-translate/core';
import { FullStoryService } from '../shared/services/fullstory.service';
import { SignalrService } from '../shared/services/signalr.service';
import * as signalR from '@microsoft/signalr';
import * as appApiResources from '../shared/globalcontants';
@Component({
    selector: 'app-home-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [AsideComponent, NgClass, HeaderComponent, TitleComponent, NgStyle, RouterOutlet, SpinnerComponent, TranslateModule]
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    public _cs: CommonService,
    private toastr: ToastrService,
    private router: Router,
    private fullStoryService: FullStoryService,
    private signalRService: SignalrService
  ) {}
  @ViewChild('sectionContainer') section: ElementRef;
  @ViewChild('bodyContainer', {static: false}) bodyContainer: ElementRef;
  @ViewChild('filterOverlay') filterOverlay: ElementRef;
  public isLoginSetting: boolean;
  public routerSubscription: Subscription;
  public showAppHeaderSubscription: Subscription;
  public showReleaseNotesChangeSubscription: Subscription;
  public offlineTabChangeSubscription: Subscription;
  public showAppHeader: boolean;
  public showReleaseNotes: boolean;
  public offlineTab: boolean;

  @HostListener('scroll', ['$event'])
  onScroll($event) {
    this._cs.scrollEvent($event);
    this._cs.onScroll($event);
  }

  onClickOutside() {
    if (this._cs.expandMenu) { this._cs.expandMenu = false; }
    this._cs.slideOpen = false;
  }

  ngOnInit() {
    this.isLoginSetting = this._cs.showSettingLogin;

    this.offlineTabChangeSubscription =  this._cs.offlineTabChange.subscribe((value) => {
      setTimeout(() => {
        this.offlineTab = value;
      }, 0);
    });

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.fullStoryService.setPage(event.urlAfterRedirects);
      });
      if(sessionStorage.getItem(appApiResources.IsConcurrentLoginIniConfigPresent) === 'true') {
        this.signalRService.startConnection();
      }
    setTimeout(() => {
      if (this.signalRService?.hubConnection?.state === signalR.HubConnectionState.Connected && this.signalRService?.hubConnection) {
        this.signalRService.addlistener();
      }
    }, 5000);
  }

  ngAfterViewInit(): void {
    this._cs.sectionContainer = this.section;
    this._cs.bodyContainer = this.bodyContainer;
    this._cs.filterOverlay = this.filterOverlay;
    this.showAppHeaderSubscription =  this._cs.showAppHeaderChange.subscribe((value) => {
      setTimeout(() => {
        this.showAppHeader = value;
      }, 0);
    });
    this.showReleaseNotesChangeSubscription =  this._cs.showReleaseNotesChange.subscribe((value) => {
      setTimeout(() => {
        this.showReleaseNotes = value;
      }, 0);
    });
    setTimeout(() => this.fullStoryService.initSession(), 0);
  }

  toastMessage() {
    this.toastr.success('Hello world!', 'Toastr fun!', {
      timeOut: 100000,
      closeButton: true,
    });

    this.toastr.show('Display my custom icon', 'Toast title', {
      closeButton: true,
    }, 'my-custom-class');
  }

  ngOnDestroy(): void {
    this.showAppHeaderSubscription.unsubscribe();
    this.showReleaseNotesChangeSubscription.unsubscribe();
    this.routerSubscription?.unsubscribe();
  }

}
